// =====================================================================
// ProtectedRoute, guards user-only routes. Anonymous visitors get
// bounced to /login with `from` saved in router state so we can
// redirect them back after a successful sign-in.
//
// While the auth context is still resolving (Supabase SDK is loading
// or getSession() hasn't returned yet) we render a small inline boot
// screen. App.jsx no longer holds the boot screen for the whole tree,
// so each protected route owns its own loading UI.
// =====================================================================

import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext.jsx";
import Spinner from "./Spinner.jsx";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="boot-screen" style={{ flexDirection: "column", gap: 18 }}>
        <img
          src="/icon.svg"
          alt=""
          width="36"
          height="36"
          style={{ opacity: 0.9 }}
        />
        <Spinner size={18} />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}
